import { sortBy } from 'lodash';
import { paragraphRegexp, specialSymbolEnum } from '@/constant';

export function fetchExistsTagPositionArr({ currentRuleArr, rowDetail }) {
  const tagPositionArr = [];
  currentRuleArr.forEach(currentRule => {
    const { columnKey, title, full_name: fullName, fieldThemeName, fieldIndex, hideLight = false } = currentRule;
    if (hideLight || !rowDetail._source[columnKey]) {
      return;
    }

    rowDetail._source[columnKey] = { data: [], ...(rowDetail._source[columnKey] || {}) };
    // 获取标签位置的start和end数组
    const tagArr = (rowDetail._source[columnKey].data || [])
      .filter(positionItem => {
        return (
          positionItem.length > 0 &&
          !isNaN(positionItem.offset) &&
          positionItem.offset !== null &&
          positionItem.offset !== ''
        );
      })
      .map(positionItem => {
        return {
          ...positionItem,
          start: positionItem.offset,
          end: positionItem.offset + positionItem.length,
          columnKey,
          columnTitle: title,
          columnFullName: fullName,
          fieldThemeName,
          fieldIndex
        };
      });
    tagPositionArr.push(...tagArr);
  });
  return sortBy(tagPositionArr, ['start', 'end']);
}

function splitTitle(paragraphTitleEnumFilter, text, titleArr = []) {
  const titleItem = text.match(paragraphRegexp);
  const titleLabel = (titleItem && titleItem[0]) || '';
  if (titleLabel) {
    const currentParagraphInfo = paragraphTitleEnumFilter[titleLabel.slice(1, -1)];
    const key = currentParagraphInfo ? currentParagraphInfo.key : 'none';
    const titleLength = titleLabel.length;
    titleArr.push({ label: titleLabel.slice(1, -1), key, info: currentParagraphInfo });
    return splitTitle(paragraphTitleEnumFilter, text.slice(titleLength), titleArr);
  } else {
    return { paragraphContent: text, titleArr };
  }
}

export function fetchTextArr({ rowDetail, paragraphTitleEnumFilter }) {
  const textArr = [];
  const point = rowDetail.para_content || '';
  // 根据文本换行内部分段
  let preEnd = 0;

  let paragraphKey = ''; // 记录的是当前内容的段落key
  let paragraphTitle = ''; // 记录的是当前内容的段落ktitle

  const newParagraph = point.split(/\n/g).map(text => {
    const { titleArr, paragraphContent } = splitTitle(paragraphTitleEnumFilter, text);
    const titleContentArr = [];
    titleArr.forEach(titleItem => {
      titleContentArr.push({
        paragraphKey: titleItem.key,
        paragraphTitle: titleItem.label,
        titleText: titleItem.label,
        isTitle: true
      });
      paragraphKey = titleItem.key;
      paragraphTitle = titleItem.label;
    });
    const textContent =
      paragraphContent.length > 0
        ? {
            start: preEnd,
            paragraphKey,
            paragraphTitle,
            textLength: paragraphContent.length,
            tagArr: [
              { textId: `${preEnd}_${paragraphContent.length}`, isTag: false, text: paragraphContent, start: preEnd }
            ]
          }
        : null;
    // 结束位置为内容长度+换行长度1
    preEnd += paragraphContent.length + 1;
    return { titleContentArr, textContent };
  });
  newParagraph.forEach(paragraphItem => {
    if (paragraphItem.titleContentArr.length > 0) {
      textArr.push(...paragraphItem.titleContentArr);
    }
    if (paragraphItem.textContent) {
      textArr.push(paragraphItem.textContent);
    }
  });

  return textArr;
}

export function formatPeriodHandle(textArr) {
  return textArr.map(item => {
    if (item.isTitle) {
      return item;
    }
    const tagArr = [];
    item.tagArr.forEach(subItem => {
      const textArrByPeriod = subItem.text.split('。');
      let preEnd = subItem.start;
      textArrByPeriod.forEach((textItem, textIndex) => {
        // 如果为空字符串，而且不是首个，则无意义
        if (textItem === '' && textIndex > 0) {
          return;
        }
        const haveNextItem = textArrByPeriod[textIndex + 1] !== undefined;
        const text = `${textItem}${haveNextItem ? '。' : ''}`;
        tagArr.push({
          ...subItem,
          start: preEnd,
          text,
          textId: `${preEnd}_${text.length}`
        });
        preEnd += text.length;
      });
    });
    return { ...item, tagArr };
  });
}

export function fetchPreEnd(tagItem) {
  const [tagStart, tagLength] = tagItem.textId.split('_').map(numStr => Number(numStr));
  return tagStart + tagLength;
}

export function formatSpecialSymbol(rowArr) {
  const reg = new RegExp(Object.keys(specialSymbolEnum).join('|'), 'g');
  return rowArr.map(textArr => {
    const newTextArr = [];
    const formatRangeArr = [];

    textArr.forEach(textItem => {
      if (textItem.isTitle) {
        newTextArr.push(textItem);
        return;
      }

      const tagArr = textItem.tagArr.map(tagItem => {
        const matchArr = [...tagItem.text.matchAll(reg)];
        if (matchArr.length < 1) {
          return tagItem;
        }
        matchArr.forEach(matchItem => {
          formatRangeArr.push({ offset: tagItem.start + matchItem.index, originText: matchItem[0] });
        });
        return {
          ...tagItem,
          originText: tagItem.text,
          text: tagItem.text.replace(reg, symbolKey => {
            return specialSymbolEnum[symbolKey];
          })
        };
      });
      newTextArr.push({ ...textItem, tagArr });
    });

    return { textArr: newTextArr, formatRangeArr };
  });
}

export function highTextBySearch(textArr, paragraphInfo, paragraphTitleEnum, options = {}) {
  const { recommendFieldDetail } = options;
  const { text: searchText, selects } = paragraphInfo;
  const isAllParagraph = selects.length === 1 && selects[0] === 'para_content';
  const selectsTitleArr = selects.map(selectKey => paragraphTitleEnum[selectKey]).filter(selectTitle => !!selectTitle);
  return textArr.map(item => {
    if (item.isTitle || (!isAllParagraph && !selectsTitleArr.includes(item.paragraphTitle))) {
      return item;
    }
    const tagArr = item.tagArr.map(subItem => {
      if (subItem.isTag || !subItem.text.includes(searchText)) {
        return subItem;
      }
      const subItemArr = [];
      const subTextArr = [{ text: subItem.text, splitByHigh: false }];
      const searchTextLength = searchText.length;
      for (let subTextIndex = 0; subTextIndex < subTextArr.length; subTextIndex++) {
        const subTextItem = subTextArr[subTextIndex];
        const firstIndexNum = subTextItem.text.indexOf(searchText);
        let preEnd = subItem.start;
        if (subTextIndex > 0) {
          preEnd =
            preEnd +
            subTextArr
              .slice(0, -1)
              .map(tItem => tItem.text)
              .join('').length;
        }
        if (firstIndexNum === -1) {
          subItemArr.push({
            isTag: false,
            isHigh: false,
            start: preEnd,
            text: subTextItem.text,
            textId: `${preEnd}_${subTextItem.text.length}`,
            splitByHigh: subTextItem.splitByHigh
          });
          break;
        }
        if (firstIndexNum === 0) {
          subItemArr.push({
            isTag: false,
            isHigh: true,
            recommendFieldDetail,
            start: preEnd,
            text: searchText,
            textId: `${preEnd}_${searchText.length}`
          });
          const nextItemText = subTextItem.text.slice(searchTextLength);
          subTextArr.push({ text: nextItemText, splitByHigh: true });
          subTextArr[subTextIndex].text = searchText;
        } else {
          const preItemText = subTextItem.text.slice(0, firstIndexNum);
          const nextItemText = subTextItem.text.slice(firstIndexNum + searchTextLength);
          const nextStart = preEnd + preItemText.length;
          subItemArr.push(
            ...[
              {
                isTag: false,
                isHigh: false,
                start: preEnd,
                text: preItemText,
                textId: `${preEnd}_${preItemText.length}`,
                splitByHigh: true
              },
              {
                isTag: false,
                isHigh: true,
                recommendFieldDetail,
                start: nextStart,
                text: searchText,
                textId: `${nextStart}_${searchTextLength}`
              }
            ]
          );
          subTextArr.push({ text: nextItemText, splitByHigh: true });
          subTextArr[subTextIndex].text = `${preItemText}${searchText}`;
        }
      }

      return subItemArr;
    });
    const newTagArr = [];
    tagArr.forEach(subItem => {
      if (Array.isArray(subItem)) {
        newTagArr.push(...subItem);
      } else {
        newTagArr.push(subItem);
      }
    });
    return { ...item, tagArr: newTagArr };
  });
}

export function fetchParagraphIndex({ textArr, tagPositionItem }) {
  return textArr.findIndex(paragraphItem => {
    if (paragraphItem.isTitle) {
      return false;
    }
    if (paragraphItem.start > tagPositionItem.start) {
      return false;
    }
    if (paragraphItem.start + paragraphItem.textLength < tagPositionItem.end) {
      return false;
    }
    return true;
  });
}

export function fetchTagTextIndex({ tagArr, tagPositionItem }) {
  return tagArr.findIndex(tagTextItem => {
    // tag-text的开始位置比标注的开始位置大则不可能渲染
    if (tagTextItem.start > tagPositionItem.start) {
      return false;
    }

    if (tagTextItem.isTag) {
      // 如果是tag-text，当前的tag标注必须长于tag-text
      if (tagPositionItem.start > tagTextItem.start + tagTextItem.text.length) {
        return false;
      }
      return tagPositionItem.end >= tagTextItem.start + tagTextItem.text.length;
    } else {
      // 如果不是tag-text，当前tag必须在span-text内
      return tagTextItem.start + tagTextItem.text.length >= tagPositionItem.end;
    }
  });
}

export function fetchNextTagItem({ currentTagTextIndex, tagArr }) {
  let nextTagIndex = -1;
  let tagTextIndex = 1;

  // 循环寻找下一个可以渲染tag-text的span-text
  while (currentTagTextIndex + tagTextIndex < tagArr.length) {
    const tagTextItem = tagArr[currentTagTextIndex + tagTextIndex];
    if (tagTextItem.isTag) {
      tagTextIndex++;
    } else {
      nextTagIndex = tagTextIndex;
      break;
    }
  }

  if (nextTagIndex === -1) {
    return -1;
  }

  return currentTagTextIndex + nextTagIndex;
}

export function fetchSentence(tagArr, currendtIndex) {
  const preArr = tagArr.slice(0, currendtIndex).reverse();
  const nextArr = tagArr.slice(currendtIndex + 1);
  let currentText = tagArr[currendtIndex].originText || tagArr[currendtIndex].text;

  for (let i = 0; i < preArr.length; i++) {
    const item = preArr[i];
    const text = item.originText || item.text;
    if (text.includes('。')) {
      break;
    } else {
      currentText = `${text}${currentText}`;
    }
  }

  if (currentText.includes('。')) {
    return currentText;
  }

  for (let i = 0; i < nextArr.length; i++) {
    const item = nextArr[i];
    const text = item.originText || item.text;
    currentText = `${currentText}${text}`;
    if (currentText.includes('。')) {
      break;
    }
  }

  return currentText;
}
